import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "message-order" }
const _hoisted_2 = { class: "order-guide" }
const _hoisted_3 = { class: "order-main" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "order-information" }
const _hoisted_6 = { class: "order-name" }
const _hoisted_7 = { class: "order-description" }
const _hoisted_8 = { class: "order-custom" }
const _hoisted_9 = { class: "order-field" }
const _hoisted_10 = { class: "field-name" }
const _hoisted_11 = { class: "field-value" }
const _hoisted_12 = { class: "field-customer-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString($setup.props.payload.content.guide), 1),
    _createElementVNode("div", _hoisted_3, [
      ($setup.props.payload.content.pic)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "order-img",
            src: $setup.props.payload.content.pic
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString($setup.props.payload.content.name), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString($setup.props.payload.content.desc), 1)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.payload.content.customField, (item) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(item.name), 1),
          _createElementVNode("span", _hoisted_11, _toDisplayString(item.value), 1),
          _createElementVNode("span", _hoisted_12, _toDisplayString(item.customerValue), 1)
        ])
      ]))
    }), 256))
  ]))
}